/* Notification chimes synthesized with the Web Audio API — no audio assets to
   embed or fetch. A soft two-note "message" chime for incoming agent replies.
   The AudioContext is created lazily and resumed on demand; if the browser
   still blocks it (no user gesture yet) the call is a silent no-op. */

let ctx: AudioContext | null = null;

function audio(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const AC =
      window.AudioContext ||
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!AC) return null;
    try {
      ctx = new AC();
    } catch {
      return null;
    }
  }
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function tone(c: AudioContext, freq: number, at: number, dur: number, peak: number): void {
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, at);
  gain.gain.exponentialRampToValueAtTime(peak, at + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, at + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(at);
  osc.stop(at + dur + 0.02);
}

/** Soft ascending two-note chime for an incoming message. */
export function playMessageChime(): void {
  const c = audio();
  if (!c) return;
  const t = c.currentTime;
  tone(c, 659.25, t, 0.16, 0.09); // E5
  tone(c, 987.77, t + 0.12, 0.22, 0.09); // B5
}
